
import { SelectButton } from 'primereact/selectbutton';
import { useState } from 'react';        

export function PropertySelectButton({propertyName, initialVal, label, id, options, onDone, optionValue, optionLabel}) {
    const [value, setValue] = useState((initialVal) ? initialVal : 0);

    return (
        <>
            <div className='w-full mb-2'>
               <label htmlFor={id + '-' + propertyName}>{label}</label> 
            </div>
            <div className='w-full flex flex-row justify-content-center'>
                <SelectButton id={id + '-' + propertyName} 
                    pt={{
                        button: {
                            className: 'px-3 py-2'
                        }
                    }}
                    value={value}
                    options={options}
                    optionValue={optionValue}
                    optionLabel={optionLabel}
                    onChange={(e) => {
                        setValue(e.value);
                        onDone(propertyName,e.value);
                    }
                    } 
                ></SelectButton>                
            </div>
        </>
    )

}